import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../api/axios';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(() => {
    const saved = localStorage.getItem('hp_admin');
    return saved ? JSON.parse(saved) : null;
  });
  const [loading, setLoading] = useState(true);

  const saveUser = (user) => {
    localStorage.setItem('hp_admin', JSON.stringify(user));
    setAdmin(user);
  };

  // Re-fetches the logged-in user (role, permissions, mustChangePassword).
  // Called on app load and after the user changes their password.
  const refreshUser = useCallback(async () => {
    const res = await api.get('/auth/me');
    saveUser(res.data.admin);
    return res.data.admin;
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('hp_token');
    if (!token) {
      setLoading(false);
      return;
    }
    refreshUser()
      .catch(() => setAdmin(null))
      .finally(() => setLoading(false));
  }, [refreshUser]);

  const login = async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    localStorage.setItem('hp_token', res.data.token);
    saveUser(res.data.admin);
    return res.data.admin;
  };

  const logout = () => {
    localStorage.removeItem('hp_token');
    localStorage.removeItem('hp_admin');
    setAdmin(null);
  };

  // Convenience flag for showing/hiding admin-only UI.
  // This is cosmetic only — the backend enforces every rule on its own.
  const isAdmin = admin?.role === 'ADMIN';

  return (
    <AuthContext.Provider value={{ admin, isAdmin, login, logout, refreshUser, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
